import { render } from "./HomeTwoView.vue?vue&type=template&id=3aa2f522"
import script from "./HomeTwoView.vue?vue&type=script&lang=js"
export * from "./HomeTwoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__